export const storeToken = (token) => {
  window.localStorage.setItem('jwt', token)
}

export const getToken = () => {
  return window.localStorage.getItem('jwt')
}

export const removeToken = () => {
  window.localStorage.removeItem('jwt')
}

export const tokenPayload = (key) => {
  let token = getToken()
  if (!token) {
    return null
  }
  let splitToken = token.split('.')
  if (!splitToken[1]) {
    return null
  }
  return key ? JSON.parse(atob(splitToken[1]))[key] : JSON.parse(atob(splitToken[1]))
}

export const checkAuth = () => {
  let payload = tokenPayload()
  if (!payload || !payload.exp || (Date.now() > payload.exp * 1000)) {
    removeToken()
    return false
  }
  return true
}

export const authHeader = () => {
  return getToken() ? 'Bearer ' + getToken() : ''
}



// WEBPACK FOOTER //
// ./src/auth.js